import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ExperienceInclusion } from '../../interfaces/application-package';

/**
 * The inclusion cockpit (Layout A): one list of every work-experience role,
 * split into "In the CV" and "Set aside", with per-row restore/set-aside.
 * Emits intent; the parent owns the HTTP calls + state refresh.
 */
@Component({
  selector: 'bst-experiences-panel',
  templateUrl: './experiences-panel.component.html',
  styleUrls: ['./experiences-panel.component.scss'],
  standalone: false,
})
export class ExperiencesPanelComponent {
  @Input() public experiences: ExperienceInclusion[] = [];
  @Input() public busy = false;
  /** Set once the consultant's edit window is closed; blocks set-aside/restore. */
  @Input() public disabled = false;
  /** Manual editing is on for this package (CV_MANUAL_EDIT_ENABLED and the
   * edit window is open): shows the drag handle, the Edit buttons and the
   * role description text, and enables drag reorder. Off by default, and
   * every one of those is gated on it, so the panel then renders the same
   * title/dates rows it did before #1420 — the description is new here even
   * though InclusionList has always been able to supply it. */
  @Input() public manualEdit = false;

  @Output() public restore = new EventEmitter<number>();
  @Output() public setAside = new EventEmitter<number>();
  @Output() public editField = new EventEmitter<
    | { field: 'role' | 'description'; experienceId: number; label: string; current: string }
    | { field: 'period'; section: 'experience'; id: number; label: string; start: string | null; end: string | null }
  >();
  @Output() public reorderRoles = new EventEmitter<number[]>();

  public get included(): ExperienceInclusion[] { return this.experiences.filter(e => e.state === 'included'); }
  public get setAsideList(): ExperienceInclusion[] { return this.experiences.filter(e => e.state === 'set_aside'); }

  public onDrop(event: CdkDragDrop<ExperienceInclusion[]>): void {
    const list = [...this.included];
    moveItemInArray(list, event.previousIndex, event.currentIndex);
    this.reorderRoles.emit(list.map(e => e.role_id));
  }
}
